import Input from './Input/index.js';
import FormField from './FormField/index.js';
import Textarea from './Textarea/index.js';
import 'react';

var index = { Input: Input, FormField: FormField, Textarea: Textarea };

export { index as default };
